// extracted by mini-css-extract-plugin
export default {"expandable-container":"adc__expandable-container--k0mNH","overflow-layout":"adc__overflow-layout--J05dz","collapse-footer":"adc__collapse-footer--KUxWO"};